export const MAIN_CLASS_NAME = 'project-source-page';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const SEARCH_CLASS_NAME = `${CONTENT_CLASS_NAME}__search`;

export const REFRESH_INTERVAL = 5000; // 5 seconds.
